var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step-inner-content" },
      [
        _c("SelectWrapper", {
          attrs: {
            item: "Recommendation",
            caption: "Provide your subscribers with a customized experience",
            price: _vm.Global.products.recommendation.price,
          },
          model: {
            value: _vm.Global.mockupConfig.services.recommendation,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.services, "recommendation", $$v)
            },
            expression: "Global.mockupConfig.services.recommendation",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          attrs: {
            item: "Advanced content protection",
            caption:
              "Benefit from VPN detection, holywood-grade content encryption",
            price: _vm.Global.products.content_protection.price,
          },
          model: {
            value: _vm.Global.mockupConfig.services.content_protection,
            callback: function ($$v) {
              _vm.$set(
                _vm.Global.mockupConfig.services,
                "content_protection",
                $$v
              )
            },
            expression: "Global.mockupConfig.services.content_protection",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          attrs: {
            item: "Content tagging",
            caption: "Add tags to access quickly the key events of your videos",
            price: _vm.Global.products.content_tagging.price,
          },
          model: {
            value: _vm.Global.mockupConfig.services.content_tagging,
            callback: function ($$v) {
              _vm.$set(_vm.Global.mockupConfig.services, "content_tagging", $$v)
            },
            expression: "Global.mockupConfig.services.content_tagging",
          },
        }),
        _vm._v(" "),
        _c("SelectWrapper", {
          attrs: {
            item: "Rich Metadata & Content enrichment",
            caption:
              "You want more information about your movies ? Images ? Actors ? We have the IMDb data ready for you",
            price: _vm.Global.products.content_enrichment.price,
          },
          model: {
            value: _vm.Global.mockupConfig.services.content_enrichment,
            callback: function ($$v) {
              _vm.$set(
                _vm.Global.mockupConfig.services,
                "content_enrichment",
                $$v
              )
            },
            expression: "Global.mockupConfig.services.content_enrichment",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nxt-out" },
          [
            _c("div", { staticClass: "bgout" }),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "btn bck", attrs: { tag: "div", to: "/look" } },
              [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "btn main txt-blk",
                attrs: { tag: "div", to: "/payment" },
              },
              [
                _c("span", { staticClass: "hvr" }),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro-block" }, [
      _c("h5", { staticClass: "txt-grt" }, [_vm._v("Additional services")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "You need more features? Choose advanced options to improve the user experience and engage your community."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }